var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.50006 2.5C3.67164 2.5 3.00006 3.17158 3.00006 4C3.00006 4.82842 3.67164 5.5 4.50006 5.5C5.32851 5.5 6.00006 4.82842 6.00006 4C6.00006 3.17158 5.32851 2.5 4.50006 2.5ZM2.00006 4C2.00006 2.61929 3.11935 1.5 4.50006 1.5C5.88076 1.5 7.00006 2.61929 7.00006 4C7.00006 5.3807 5.88076 6.5 4.50006 6.5C3.11935 6.5 2.00006 5.3807 2.00006 4ZM10.8536 4.64644C11.0489 4.84171 11.0489 5.1583 10.8536 5.35355L8.85361 7.35355C8.65836 7.5488 8.34176 7.5488 8.14651 7.35355L7.14651 6.35355C6.95126 6.1583 6.95126 5.8417 7.14651 5.64645C7.34176 5.4512 7.65836 5.4512 7.85361 5.64645L8.50006 6.2929L10.1465 4.64644C10.3418 4.45118 10.6584 4.45118 10.8536 4.64644ZM2.10139 7.66975C2.73717 7.2459 3.58669 7 4.50006 7C5.41341 7 6.26296 7.2459 6.89871 7.66975C7.53101 8.0913 8.00006 8.7285 8.00006 9.5C8.00006 9.77615 7.77621 10 7.50006 10C7.22391 10 7.00006 9.77615 7.00006 9.5C7.00006 9.1669 6.79751 8.80415 6.34401 8.5018C5.89401 8.2018 5.24356 8 4.50006 8C3.75658 8 3.1061 8.2018 2.65609 8.5018C2.20259 8.80415 2.00006 9.1669 2.00006 9.5C2.00006 9.77615 1.7762 10 1.50006 10C1.22392 10 1.00006 9.77615 1.00006 9.5C1.00006 8.7285 1.46911 8.0913 2.10139 7.66975Z",
    fill: "#15C7A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssign);
export default __webpack_public_path__ + "static/media/assign.0f2329f7a06c8c45a8e22e2b953c1db6.svg";
export { ForwardRef as ReactComponent };